<template>
  <div class="main__section">
    <h1 class="section__title">
      Аналитика -> Статистика по триггерам
    </h1>
    <div class="main__body">
      <div class="form-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">Название триггера</th>
            <th scope="col">Telegram</th>
            <th scope="col">Viber</th>
            <th scope="col">SMS</th>
            <th scope="col">Email</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in statistics" v-bind:key="item.id">
            <th scope="row">{{ index + 1}}</th>
            <td>{{ item.name }}</td>
            <td>{{ item.telegram }}</td>
            <td>{{ item.viber }}</td>
            <td>{{ item.sms }}</td>
            <td>{{ item.email }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LineChart from "./charts/line-chart";
export default {
  name: 'statistics-triggers',
  data: function(){
    return{
      statistics: [],
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getStatistics();
  },
  methods: {
    getStatistics: function(){
      this.isLoading = true;
      axios.post('getStatisticsTrigger').then(response => {
        var status = response.data.status;
        if(status){
          this.statistics = response.data.statistics;
          this.isLoading = false;
        }
      });
    },
  },
  components: {
    loading, LineChart
  }
}
</script>
